import { MESSAGE_CODE, MESSAGE_FROM, MESSAGE_TYPE } from "../constants/Notifications";
import { SM_QUEUE_SERVER } from "../constants/constants";
import { messageOngoingCallIvr, triggerNotifications } from "../Helpers/helperMessages";
import { ivrListModel } from "../mappers/models.mapper";

export const svrGetIVRList = (SDK) => {
    const isActiveIVR = SDK.sharedData.getGeneralPermissions()[117];
    
    if (isActiveIVR !== '1') {
        triggerNotifications(SDK, MESSAGE_CODE.CALL_CONTROLS[10702], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
        return;
    }

    const objResponse = SDK.apiCont.getObjectResponse();
    SDK.apiCont.ongoingCallIvr(objResponse);

    objResponse.onError = (messageError) => {
        SDK.errorEvents.errorIVRList([]);
        console.error("[getIVRList] [Error]: ", messageError);
    };

    objResponse.onSuccess = (response) => {
        const isEmptyResponse = Object.keys(response).length === 0;

        const messageCode = isEmptyResponse 
            ? MESSAGE_CODE.CALL_CONTROLS[10703] 
            : MESSAGE_CODE.CONNECTION_ALERTS[200];
        const messageType = isEmptyResponse ? MESSAGE_TYPE.WARN : MESSAGE_TYPE.SUCCESS;

        triggerNotifications(SDK, messageCode, messageType, MESSAGE_FROM.SDK);

        const ivrModel = ivrListModel(response);
        SDK.svrEvents.onIVRList(ivrModel);
    };
};

export const svrStartIVR = (svrResource, ivrID) => {
    const message = messageOngoingCallIvr(parseInt(ivrID));
    svrResource.sendToRabbit(SM_QUEUE_SERVER, message);
}